import { useSyncExternalStore } from 'react';

import { impersonationStore } from '@/features/platform/api/impersonation';

/**
 * Subscribes to the in-memory support session.
 *
 * The server snapshot is `null`: there is no session during SSR or the first
 * paint, and claiming otherwise would flash a banner that then disappears.
 */
export function useImpersonation() {
  return useSyncExternalStore(
    (listener) => impersonationStore.subscribe(listener),
    () => impersonationStore.get(),
    () => null,
  );
}
